import { SET_APP_NOTIFICATION_DATA, SET_APP_STATUS } from '../../actionTypes/notifications'

const initialState = {
	appNotificationData: null,
	isAppOpen: true,
}

export function notificationsReducer (state = initialState, action) {
	switch (action.type) {
		case SET_APP_NOTIFICATION_DATA:
			return {
				...state,
				appNotificationData: action.value,
			}
		case SET_APP_STATUS:
			return {
				...state,
				isAppOpen: action.value,
			}
		default:
			return state
	}
}
